import { Box, Flex, Text } from '@chakra-ui/react';
import MyDiv from './employementExperinceCard.style';
import { ICandidateList } from '../../OnboardCandidateList/modal';

interface ExperinceProps {
  experience?: any
}

const EmployementExperinceCard = ({ experience }: ExperinceProps) => {
  return (
    <MyDiv>
      <Box className="cards">
        <Box px={4} py={2}>
          <Text className="font-poppins text_xxl text_medium">
            Candidate Employment & Experience
          </Text>

          {/* If no experience records, show Fresher */}
          {(!experience?.experience || experience.experience.length === 0) ? (
            <Flex justify="space-between" mt={3}>
              <Text className="font-poppins text_lg text_medium">Experience</Text>
              <Text className="font-poppins text_lg text_regular">Fresher</Text>
            </Flex>
          ) : (
            experience.experience.map((exp: any, index: number) => (
              <Box key={index} mt={4} p={3} border="1px solid #e0e0e0" borderRadius="md">
                <Flex justify="space-between" mt={1}>
                  <Text className="font-poppins text_lg text_medium">Experience in month</Text>
                  <Text className="font-poppins text_lg text_regular">{exp.experience_In_Month} months</Text>
                </Flex>

                <Flex justify="space-between" mt={2}>
                  <Text className="font-poppins text_lg text_medium">Last Organisation</Text>
                  <Text className="font-poppins text_lg text_regular">{exp.organization_Name}</Text>
                </Flex>
              </Box>
            ))
          )}
        </Box>
      </Box>
    </MyDiv>
  );
};

export default EmployementExperinceCard;
